module.exports = __webpack_public_path__ + "img/5.6ad1d683.gif";